export default __webpack_public_path__ + "static/media/createCollectionsDark.f1538d43.png";